<div id="breadcrumb-navigation" class="breadcrumb">
  {{ labels.administration }}
  <a
    id="actuaciones-contractuales-breadcrumb-link"
    class="breadcrumb-link selected"
    [routerLink]="['/wapi/admin/actuaciones-contractuales']"
  >
    &nbsp;>&nbsp;{{ labels.actuacionesContractuales }}
  </a>
</div>

<br /><br />

<div id="actuaciones-contractuales-main-container" class="container">
  <mat-card id="actuaciones-contractuales-card">
    <div id="actuaciones-contractuales-header" class="header-options">
      <div id="actuaciones-contractuales-title" class="title">
        <div class="title-wrapper">
          <h1 class="main-title">{{ labels.actuacionesContractuales }}</h1>
        </div>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          class="filter-button"
          (click)="toggleSearch()"
          matTooltip="Filtro"
        >
          <mat-icon>filter_list</mat-icon>
          FILTRO
        </button>
        <button
          mat-raised-button
          color="primary"
          class="create-button"
          (click)="openCreateModal()"
          matTooltip="{{ labels.createActuacionContractual }}"
        >
          <mat-icon>add</mat-icon>
          {{ labels.createActuacionContractual }}
        </button>
      </div>
    </div>

    <!-- Search Panel -->
    @if (showSearchPanel) {
      <div class="search-panel">
        <div class="filters-grid">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar actuaciones contractuales</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              (input)="searchActuacionesContractuales($any($event.target).value)"
              placeholder="Buscar por tipo..."
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- Column filters -->
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Tipo</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.tipo"
              (input)="onColumnFilterChange('tipo', $any($event.target).value)"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Estado (activo/inactivo)</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.status"
              (input)="onColumnFilterChange('status', $any($event.target).value)"
            />
          </mat-form-field>
        </div>
        <button
          mat-stroked-button
          color="primary"
          (click)="resetFilters()"
          style="height: 40px; align-self: center"
        >
          <mat-icon style="margin-right: 6px">filter_alt_off</mat-icon>
          Limpiar filtros
        </button>
      </div>
    }

    <div id="actuaciones-contractuales-table-section" class="table-container">
      @if (loading$ | async) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>{{ labels.loadingActuacionesContractuales }}</p>
        </div>
      } @else if (error$ | async) {
        <div class="error-container">
          <p class="error-message">{{ error$ | async }}</p>
          <button mat-raised-button color="primary" (click)="loadActuacionesContractuales()">
            Retry
          </button>
        </div>
      } @else {
        @if (dataSource.data.length > 0) {
          <div class="table-wrapper">
            <table
              id="actuaciones-contractuales-table"
              mat-table
              [dataSource]="dataSource"
              [trackBy]="trackByActuacionId"
              class="mat-elevation-z8 full-width-table styled-table"
              matSort
            >
              <!-- ID Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableId }}</th>
                <td mat-cell *matCellDef="let element">{{ element.actuacionId }}</td>
              </ng-container>

              <!-- Tipo Column -->
              <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableTipo }}</th>
                <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableStatus }}</th>
                <td mat-cell *matCellDef="let element">
                  <span [class]="element.estado ? 'status-active' : 'status-inactive'">
                    {{ element.estado ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableActions }}</th>
                <td mat-cell *matCellDef="let element">
                  <div class="action-buttons">
                    <button
                      mat-icon-button
                      class="view-button"
                      matTooltip="{{ labels.tooltipView }}"
                      (click)="viewDetail(element, false)"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      class="edit-button"
                      matTooltip="{{ labels.tooltipEdit }}"
                      (click)="openCreateModal(element)"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      class="toggle-button"
                      [matTooltip]="element.estado ? 'Desactivar' : 'Activar'"
                      (click)="toggleActuacionContractualStatus(element)"
                    >
                      <mat-icon>{{ element.estado ? 'toggle_on' : 'toggle_off' }}</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: tableColumns"
                class="actuacion-contractual-row"
              ></tr>
            </table>

            <!-- Paginador -->
            <mat-paginator
              #paginator
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              [showFirstLastButtons]="true"
              (page)="onPageChange()"
              aria-label="Seleccionar página de actuaciones contractuales"
            >
            </mat-paginator>
          </div>
        } @else {
          <div class="no-data-container">
            <mat-icon class="no-data-icon">inbox</mat-icon>
            <p>{{ labels.noActuacionesContractuales }}</p>
            <button mat-raised-button color="primary" (click)="openCreateModal()">
              {{ labels.createActuacionContractual }}
            </button>
          </div>
        }
      }
    </div>
  </mat-card>
</div>

<ng-template #createActuacionContractualModal>
  <h2 id="actuacion-contractual-modal-title" mat-dialog-title>
    {{ isEditing ? labels.editActuacionContractual : labels.createActuacionContractual }}
  </h2>

  <mat-dialog-content id="actuacion-contractual-modal-content" class="modal-content">
    <form id="actuacion-contractual-form" [formGroup]="actuacionContractualForm">
      <!-- ID Field (solo para edición) -->
      @if (isEditing && editingActuacionContractual) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.actuacionId }}</mat-label>
          <input matInput [value]="editingActuacionContractual.actuacionId" readonly />
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>
      }

      <!-- Tipo Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.tipo }}</mat-label>
        <input
          matInput
          formControlName="tipo"
          placeholder="Ingrese el tipo de actuación contractual"
          [class.error-field]="hasError('tipo')"
        />
        @if (hasError('tipo')) {
          <mat-error>{{ getErrorMessage('tipo') }}</mat-error>
        }
      </mat-form-field>

      <!-- Status Field -->
      <div class="status-field">
        <mat-slide-toggle formControlName="estado" color="primary">
          {{ labels.estado }}
        </mat-slide-toggle>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions id="actuacion-contractual-modal-actions" align="end">
    <button
      id="save-actuacion-contractual-button"
      mat-button
      mat-raised-button
      color="primary"
      (click)="saveActuacionContractual()"
      [disabled]="actuacionContractualForm.invalid"
    >
      <mat-icon>save</mat-icon>
      {{ labels.save }}
    </button>
    <button id="cancel-actuacion-contractual-button" mat-button (click)="closeModal()">
      {{ labels.cancel }}
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #detailModal>
  <div class="detail-modal-container">
    <!-- Header -->
    <div class="detail-modal-header">
      <h2 id="detail-modal-title" mat-dialog-title>Detalle de Actuación Contractual</h2>
    </div>

    <!-- Content -->
    <mat-dialog-content id="detail-modal-content" class="detail-modal-content">
      <div class="detail-info">
        <div class="detail-row">
          <span class="detail-label">ID:</span>
          <span class="detail-value">{{ detailBeingViewed?.actuacionId }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Tipo:</span>
          <span class="detail-value">{{ detailBeingViewed?.tipo }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Estado:</span>
          <span class="detail-value">
            <span
              class="status-badge"
              [class]="detailBeingViewed?.estado ? 'status-active' : 'status-inactive'"
            >
              {{ detailBeingViewed?.estado ? 'Activo' : 'Inactivo' }}
            </span>
          </span>
        </div>
      </div>
    </mat-dialog-content>

    <!-- Actions -->
    <mat-dialog-actions id="detail-modal-actions" align="end" class="detail-modal-actions">
      <button id="close-detail-button" mat-button mat-dialog-close class="close-detail-button">
        {{ labels.close }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
